export type MenuItem =
    | "home"
    | "search"
    | "news"
    | "tutorials"
    | "games"
    | "infographics"
    | "moon"
    | "pickLang"
    | "followUs";

interface MenuItemConfig {
    dc: number; // Desktop Col
    dcs: number; // Desktop Col Span
    mr: number; // Mobile Row
    mc?: number; // Mobile Col
    mcs: number; // Mobile Col Span
    p?: string; // path
    m?: string; // active match
}

export type MenuRecordEntry = [MenuItem, MenuItemConfig];

export const menuConfig: Record<MenuItem, MenuItemConfig> = {
    search: { dc: 7, dcs: 1, mr: 1, mc: 3, mcs: 1 },
    home: { dc: 1, dcs: 1, mr: 1, mcs: 2, p: "" },
    news: { dc: 2, dcs: 1, mr: 2, mcs: 4 },
    tutorials: { dc: 3, dcs: 1, mr: 3, mcs: 4 },
    games: { dc: 4, dcs: 1, mr: 4, mcs: 4, m: `(games|quiz|outcome-quiz)` },
    infographics: { dc: 5, dcs: 1, mr: 5, mcs: 4 },
    moon: { dc: 6, dcs: 1, mr: 6, mcs: 4, p: "moon-calendar" },
    pickLang: { dc: 9, dcs: 1, mr: 7, mcs: 4 },
    followUs: { dc: 8, dcs: 1, mr: 8, mcs: 4 },
};

type AnimatedMenuItem = Exclude<MenuItem, "search">;
interface AnimationConfig {
    o: number; // Open Order
    c: number; // Close Order
}

export const animatedMenuItems: AnimatedMenuItem[] = [
    "home",
    "news",
    "tutorials",
    "games",
    "infographics",
    "moon",
    "pickLang",
    "followUs",
];

export const menuAnimConfig: Record<AnimatedMenuItem, AnimationConfig> =
    animatedMenuItems.reduce((m, key, i, arr) => {
        m[key] = { o: i + 1, c: arr.length - i };
        return m;
    }, {} as Record<AnimatedMenuItem, AnimationConfig>);

export const getDelay = (order: number) => 40 * order;

export const menuBreakpoint = "desktop";

export const menuAnimLength = "0.2s";
